import React from 'react';
import data from '../data/fistSlideData.json';
import styles from '../styles/survey.module.css';

const FirstQuestion = ({ onQuestionPress }) => {

  const surveyData = data.slideFirst;

  const questionPress = (id) => {
    onQuestionPress(id);
  }

  return (
    <div>
      <h2 className={styles.header}>What brings you to<br />Device Tracker Plus?</h2>
      <div className={styles.questionContainer}>
        {surveyData.map(({ id, title, description, logo }) => (
          <div key={id} className={styles.surveyQuestion} onClick={() => questionPress(id)}>
            <img src={require(`../../../assets/suvreyImages/surveyIcons/${logo}`)} alt="surveyIcon" className={styles.surveyIcon} />
            <div className={styles.questionTextContent}>
              <p className={styles.questionTitle}>{title}</p>
              <p className={styles.questionDescription}>{description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default FirstQuestion